import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Shared page-level loading indicator: a spinning, glowing gold ingot.
 *
 * Every full-page "loading" state should use this so the app looks the same
 * whichever market or report you land on. Small inline spinners (buttons, a
 * single table cell) stay as CircularProgress - the ingot is too heavy there.
 */
function GoldIngotLoader({ label = 'Loading...', size = 120, minHeight = 400 }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight={minHeight}
    >
      <Box
        component="img"
        src="/gold-ingot.svg"
        alt={label}
        sx={{
          width: size,
          height: 'auto',
          animation: 'ingotSpin 2.4s linear infinite, ingotGlow 1.5s ease-in-out infinite alternate',
          // rotateY keeps the ingot upright while it turns, so it reads as a
          // spinning object rather than a tumbling one
          '@keyframes ingotSpin': {
            '0%': { transform: 'perspective(600px) rotateY(0deg)' },
            '100%': { transform: 'perspective(600px) rotateY(360deg)' }
          },
          '@keyframes ingotGlow': {
            '0%': { filter: 'drop-shadow(0 0 5px #FFD700)' },
            '100%': { filter: 'drop-shadow(0 0 22px #FFD700)' }
          }
        }}
      />
      <Typography variant="body1" sx={{ mt: 2, color: '#FFD700', fontWeight: 'bold' }}>
        {label}
      </Typography>
    </Box>
  );
}

export default GoldIngotLoader;
